export const COMPANY = {
  name: "Sky Mark Co.",
  tagline: "Precision. Performance. Promise.",
  description:
    "Industrial Supply, Steel Fabrication & Coating Solutions",
  fullDescription:
    "Riyadh-based industrial supply, CNC fabrication, steel fabrication, and coating solutions company serving contractors, infrastructure projects, and industrial clients across Saudi Arabia.",
  address: {
    full: "RNNA4002، 4002 خضره، 6416, Al Mashael, Riyadh 14321, Saudi Arabia",
    short: "RNNA4002",
  },
  contactPerson: {
    name: "Naveed Iqbal",
    designation: "Sales & Operations Manager",
  },
  phone: "+966 57 244 4365",
  email: {
    direct: "naveed@skymarkco.com",
    general: "info@skymarkco.com",
  },
  hours: {
    days: "Saturday to Thursday",
    time: "8:00 AM to 6:00 PM",
    friday: "Closed",
  },
  googleMaps: "https://maps.app.goo.gl/pwLX62TaSCydmP2i6",
  whatsapp: "https://wa.me/966572444365?text=Hello%20Sky%20Mark%20Co.%2C%20I%20would%20like%20to%20inquire%20about%20your%20products%20and%20services",
} as const;

export const SEO = {
  home: {
    title:
      "Sky Mark Co. | Industrial Supply, CNC Fabrication, Steel Fabrication & Coating Solutions in Riyadh",
    description:
      "Sky Mark Co. is a Riyadh-based company providing industrial supply, electrical and mechanical materials, civil materials, CNC laser cutting, steel fabrication, powder coating, epoxy coating, and project-related solutions across Saudi Arabia.",
    keywords: [
      "Sky Mark Co",
      "industrial supply Riyadh",
      "CNC laser cutting Riyadh",
      "steel fabrication Saudi Arabia",
      "fabrication company Riyadh",
      "powder coating Riyadh",
      "epoxy coating Saudi Arabia",
      "electrical supply Riyadh",
      "mechanical supply Riyadh",
      "civil materials Saudi Arabia",
      "project materials supplier Saudi Arabia",
      "tube fabrication Riyadh",
      "press brake bending Saudi Arabia",
      "custom fabrication Riyadh",
      "industrial supplier Saudi Arabia",
    ],
  },
} as const;

export const LOCAL_BUSINESS_JSON = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: COMPANY.name,
  description: COMPANY.fullDescription,
  address: {
    "@type": "PostalAddress",
    streetAddress: "RNNA4002، 4002 خضره، 6416, Al Mashael",
    addressLocality: "Riyadh",
    addressRegion: "Riyadh",
    postalCode: "14321",
    addressCountry: "SA",
  },
  telephone: COMPANY.phone,
  email: COMPANY.email.general,
  url: "https://skymarkco.com",
  areaServed: {
    "@type": "Country",
    name: "Saudi Arabia",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "08:00",
      closes: "18:00",
    },
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: COMPANY.phone,
    contactType: "Sales & Operations",
    availableLanguage: ["English"],
  },
};
